// extracted by mini-css-extract-plugin
export default {"Text":"VBldqF5Qj4RbqTQ8fCk2"};